import jwt_decode from 'jwt-decode'

interface DecodedToken {
  exp: number
}

const DEFAULT_THRESHOLD_MS = 10 * 60 * 1000 // 10 minutes

interface TokenExpirationCheckResult {
  timeLeft: number
  isExpired: boolean
  isNearExpiration: boolean
}

const useTokenExpirationCheck = (getToken: () => string | null) => {
  return (nearExpirationThresholdMs: number = DEFAULT_THRESHOLD_MS): TokenExpirationCheckResult => {
    const token = getToken()

    if (!token) {
      return {timeLeft: 0, isExpired: true, isNearExpiration: false}
    }

    try {
      const decodedToken = jwt_decode<DecodedToken>(token)
      const expirationTime = decodedToken.exp * 1000 // Convert to milliseconds
      const currentTime = Date.now()
      const timeUntilExpiration = expirationTime - currentTime

      if (timeUntilExpiration <= 0) {
        // Token is expired
        return {timeLeft: 0, isExpired: true, isNearExpiration: false}
      } else if (timeUntilExpiration <= nearExpirationThresholdMs) {
        // Token will expire soon
        return {timeLeft: timeUntilExpiration, isExpired: false, isNearExpiration: true}
      } else {
        // Token is valid and not expiring soon
        return {timeLeft: timeUntilExpiration, isExpired: false, isNearExpiration: false}
      }
    } catch (error) {
      // Error decoding token, its probably invalid - consider it expired
      console.error('Error decoding token:', error)
      return {timeLeft: 0, isExpired: true, isNearExpiration: false}
    }
  }
}

export default useTokenExpirationCheck
